import moment from 'moment';
import { FilterMatchMode } from 'primereact/api';
import {
  dateRangeFilterTemplate,
  dateRangeFilterFunction,
  timeRangeFilterTemplate,
  timeRangeFilterFunction,
  textFilterTemplate,
  multiSelectFilterTemplate,
} from '../../../../components/shared/DataTable/filterComponents';
import { getLocalizedCurrencyLabel } from '../../../../helpers/invoiceHelpers';
import { INVOICE_TYPE_LABELS } from '../../../../config/invoice/constants';

const STATUS_OPTIONS = [
  { label: 'SUBMITTED', value: 'ACCEPTED' },
  { label: 'IN_DRAFT', value: 'IN_DRAFT' },
  { label: 'not_submitted', value: 'REJECTED' },
];

export const ROUTES = [
  {
    label: 'sme',
    link: 'additional-functionalities/sme',
  },
  {
    label: 'additional-functionalities',
    link: 'additional-functionalities',
  },
  // {
  //   label: 'breadcrumb_e_invoicing',
  //   link: 'e-invoicing',
  // },
];

export const COLUMNS = (t, getActions, renderStatus, language) => () =>
  [
    {
      label: 'invoice_list.invoice_issue_date',
      value: 'issueDateTime',
      filterField: 'issueDateTime',
      body: (rowData) =>
        rowData.issueDateTime
          ? moment(rowData.issueDateTime, 'YYYY-MM-DD hh:mm:ss').format(
              'DD MMM YYYY',
            )
          : '-',
      sortable: false,
      filter: true,
      showSortInFilter: true,
      isDateColumn: true,
      dataType: 'date',
      filterMatchMode: FilterMatchMode.CUSTOM,
      filterElement: dateRangeFilterTemplate,
      filterFunction: dateRangeFilterFunction,
    },
    {
      label: 'invoice_list.invoice_issue_time',
      value: 'issueTime',
      body: (rowData) =>
        rowData.issueDateTime
          ? moment(rowData.issueDateTime, 'YYYY-MM-DD HH:mm:ss').format(
              'hh:mm:ss A',
            )
          : '-',
      sortable: false,
      filter: true,
      showSortInFilter: true,
      dataType: 'time',
      filterMatchMode: FilterMatchMode.CUSTOM,
      filterElement: timeRangeFilterTemplate,
      filterFunction: timeRangeFilterFunction,
    },
    {
      label: 'invoice_list.invoice_type_discription',
      value: 'invoiceTypeEnum',
      sortable: false,
      filter: true,
      showSortInFilter: true,
      filterMatchMode: FilterMatchMode.CONTAINS,
      body: (rowData) =>
        INVOICE_TYPE_LABELS(language)[rowData.invoiceTypeEnum] || '-',
      filterElement: (options) =>
        textFilterTemplate(
          options,
          t('search_by', {
            column: t('invoice_list.invoice_type_discription'),
          }),
        ),
    },
    {
      label: 'invoice_list.type_of_note',
      value: 'invoiceTypeTransaction',
      body: (rowData) => rowData.invoiceTypeTransaction || '-',
      sortable: false,
      filter: true,
      showSortInFilter: true,
      filterMatchMode: FilterMatchMode.CONTAINS,
      filterElement: (options) =>
        textFilterTemplate(
          options,
          t('search_by', { column: t('invoice_list.type_of_note') }),
        ),
    },
    {
      label: 'invoice_list.invoice_reference_number',
      value: 'invoiceNumber',
      sortable: false,
      filter: true,
      showSortInFilter: true,
      filterMatchMode: FilterMatchMode.CONTAINS,
      filterElement: (options) =>
        textFilterTemplate(
          options,
          t('search_by', {
            column: t('invoice_list.invoice_reference_number'),
          }),
        ),
    },
    {
      label: 'invoice_list.customer_name',
      value: 'buyerName',
      sortable: false,
      filter: true,
      showSortInFilter: true,
      filterMatchMode: FilterMatchMode.CONTAINS,
      filterElement: (options) =>
        textFilterTemplate(
          options,
          t('search_by', { column: t('invoice_list.customer_name') }),
        ),
    },
    {
      label: 'invoice_list.customer_vat',
      value: 'buyerVatNumber',
      sortable: false,
      filter: true,
      showSortInFilter: true,
      filterMatchMode: FilterMatchMode.CONTAINS,
      filterElement: (options) =>
        textFilterTemplate(
          options,
          t('search_by', { column: t('invoice_list.customer_vat') }),
        ),
    },
    {
      label: 'invoice_list.currency',
      value: 'currency',
      body: (rowData) => getLocalizedCurrencyLabel(rowData.currency, language),
      sortable: false,
      filter: true,
      showSortInFilter: true,
      filterMatchMode: FilterMatchMode.CONTAINS,
      filterElement: (options) =>
        textFilterTemplate(
          options,
          t('search_by', { column: t('invoice_list.currency') }),
        ),
    },
    {
      label: 'invoice_list.invoice_net_total',
      value: 'totalExcludingVat',
      body: (rowData) =>
        new Intl.NumberFormat().format(rowData.totalExcludingVat) || '-',
      sortable: false,
      filter: true,
      headerStyle: { minWidth: '150px' },
      showSortInFilter: true,
      filterMatchMode: FilterMatchMode.CONTAINS,
      filterElement: (options) =>
        textFilterTemplate(
          options,
          t('search_by', { column: t('invoice_list.invoice_net_total') }),
        ),
    },
    {
      label: 'invoice_list.invoice_vat_total',
      value: 'vatTotalAmount',
      body: (rowData) =>
        new Intl.NumberFormat().format(rowData.vatTotalAmount) || '-',
      sortable: false,
      filter: true,
      showSortInFilter: true,
      filterMatchMode: FilterMatchMode.CONTAINS,
      filterElement: (options) =>
        textFilterTemplate(
          options,
          t('search_by', { column: t('invoice_list.invoice_vat_total') }),
        ),
    },
    {
      label: 'invoice_list.invoice_gross_total',
      value: 'grossTotalIncludingVat',
      body: (rowData) =>
        new Intl.NumberFormat().format(rowData.grossTotalIncludingVat) || '-',
      sortable: false,
      headerStyle: { minWidth: '150px' },
      filter: true,
      showSortInFilter: true,
      filterMatchMode: FilterMatchMode.CONTAINS,
      filterElement: (options) =>
        textFilterTemplate(
          options,
          t('search_by', { column: t('invoice_list.invoice_gross_total') }),
        ),
    },

    {
      field: 'invoiceStatus',
      value: 'invoiceStatus',
      label: t('invoice_list.invoice_status'),
      body: (rowData) => {
        return renderStatus({ status: rowData.invoiceStatus, t });
      },
      sortable: false,
      filter: true,
      showSortInFilter: true,
      filterMatchMode: FilterMatchMode.CUSTOM,
      filterElement: (options) =>
        multiSelectFilterTemplate(
          { ...options, placeholder: t('invoice_list.invoice_status') },
          STATUS_OPTIONS.map((o) => ({
            ...o,
            label: t(`invoice_list.${o.label}`),
          })),
        ),
      filterFunction: (value, filter) => {
        if (!filter || filter.length === 0) {
          return true;
        }
        if (value === null || value === undefined) {
          return false;
        }
        // OR logic: check if value is in the filter array
        return filter.includes(String(value));
      },
    },
    {
      field: 'action',
      label: t('common.actions'),
      body: (rowData) => {
        return getActions(rowData.invoiceStatus, rowData);
      },
    },
  ];

// PrimeReact popup column filters need initial filter models for each field.
// Note: CUSTOM filters should use simple { value, matchMode } structure, not constraints
// Constraints are only for built-in filter modes (CONTAINS, STARTS_WITH, etc.)
export const SEARCH_CONFIG = {
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  issueDateTime: { value: null, matchMode: FilterMatchMode.CUSTOM },
  issueTime: { value: null, matchMode: FilterMatchMode.CUSTOM },
  invoiceTypeEnum: {
    operator: 'and',
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  invoiceTypeTransaction: {
    operator: 'and',
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  invoiceNumber: {
    operator: 'and',
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  buyerName: {
    operator: 'and',
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  buyerVatNumber: {
    operator: 'and',
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  currency: {
    operator: 'and',
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  totalExcludingVat: {
    operator: 'and',
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  vatTotalAmount: {
    operator: 'and',
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  grossTotalIncludingVat: {
    operator: 'and',
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  invoiceStatus: { value: null, matchMode: FilterMatchMode.CUSTOM },
};
